<script>
  import { scale } from 'svelte/transition';

  export let xScale;
  export let margin;
  export let height;
  export let width;
  export let filterFunc = (d) => true; // Default filter function that includes all ticks
  export let formatFunc = (d) => d; // Default format function that returns the tick as is

  // Function to filter the ticks based on the provided filter function
  const filterTicks = (domain) => domain.filter(filterFunc);
</script>

{#if xScale}
  <g transform="translate(0,{height - margin.bottom + 1})">
    <line stroke="currentColor" x1={margin.left} x2={width - margin.right} />
    {#each xScale.domain() as tick}
      <line
        stroke="currentColor"
        x1={xScale(tick) + xScale.bandwidth() / 2}
        x2={xScale(tick) + xScale.bandwidth() / 2}
        y2="6" />
    {/each}

    {#each filterTicks(xScale.domain()) as tick}
      <g transform={`translate(${xScale(tick) + xScale.bandwidth() / 2}, 0)`}>
        <text
          font-size="10px"
          fill="currentColor"
          text-anchor="middle"
          dy="0.71em"
          y="9">
          {formatFunc(tick)}
        </text>
      </g>
    {/each}
  </g>
{/if}
